import {
  Activity,
  CheckCircle2,
  ShoppingBag,
  ShoppingCart,
  Store,
  Zap,
} from 'lucide-react';

/** Shared funnel stage icons/colors — used by KPI cards and Conversion Funnel. */
export const FUNNEL_STAGE_META = {
  visits: { icon: Activity, color: '#3b82f6' },
  vendorViews: { icon: Store, color: '#14b8a6' },
  cart: { icon: ShoppingCart, color: '#a855f7' },
  checkout: { icon: Zap, color: '#f59e0b' },
  placed: { icon: ShoppingBag, color: '#06b6d4' },
  delivered: { icon: CheckCircle2, color: '#6366f1' },
};

export const getFunnelStageMeta = (key) => (
  FUNNEL_STAGE_META[key] || { icon: Activity, color: '#3b82f6' }
);
